import React, { useEffect, useState } from 'react'
import companyServices from '../../company/companyServices';
import { useAppData } from '../../../../../context/AppDataContext';

function CompanySelectComponent({setCompanyDetails}) {
    const {companyList,getCompanyList} = useAppData();
    const [selectedCompany,setSelectedCompany] = useState(0);

    useEffect(()=>{
        getCompanyList();
    },[])
    

    useEffect(()=>{
        if(companyList){
            setCompanyDetails(companyList[selectedCompany]);
        }
    },[selectedCompany])

    
    return (
        <div>
            <div class="form-floating mb-3">
                <select className="form-control"
                        onChange={(e)=> 
                            setSelectedCompany(e.target.value)
                        }
                        value={selectedCompany}
                    >
                    {companyList?.map((company,i)=>
                        <option value={i}>{company.companyName}</option>
                    )}
                </select>
                <label>Select Company</label>
            </div>
        </div>
    )
}

export default CompanySelectComponent